export const addNotAcceptedToSearchParams = (): string => {
  const locSearch = location.search
  if (locSearch.includes('not-accepted')) {
    return locSearch
  }

  if (locSearch) {
    return locSearch + '&not-accepted=1'
  }

  return 'not-accepted=1'
}
